import OrderStrategy from "./OrderStrategy";

export const AfterConfirmByCustomer = OrderStrategy(0, 'edi.orders.add_order.order_lifecycle.executor_invoice_creation_strategy.select.0')
export const OnShipmentWaybillCreation = OrderStrategy(1, 'edi.orders.add_order.order_lifecycle.executor_invoice_creation_strategy.select.1')